import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { authGuard } from '@/core/guards/auth.guard';

export const appRoutes: Routes = [
    { path: 'login', loadComponent: () => import('@/features/auth/pages/login/login.component').then((c) => c.LoginComponent) },
    { path: 'forgot-password', loadComponent: () => import('@/features/auth/pages/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent) },
    { path: 'change-password', loadComponent: () => import('@/features/auth/pages/change-password/change-password.component').then((c) => c.ChangePasswordComponent) },
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            // {
            //     path: '',
            //     loadComponent: () => import('@/features/approve-purchase-request/pages/approve-purchase-request-list/approve-purchase-request-list').then((c) => c.ApprovePurchaseRequestList),
            //     data: { breadcrumb: 'Approve Purchase Request Management' }
            // },
            {
                path: 'purchase-request-management',
                loadChildren:() => import('@/features/approve-purchase-request/approve-purchase-request-routing-module').then(m => m.ApprovePurchaseRequestRoutingModule),
                data: { breadcrumb: 'Approve Purchase Request Management' }
            },
            {
                path: 'approve-purchase-management',
                loadChildren:() => import('@/features/approve-purchase-request-cash/approve-purchase-request-cash-routing-module').then(m => m.ApprovePurchaseRequestCashRoutingModule),
                data: { breadcrumb: 'Approve Purchase Request Cash' }
            },
            {
                path: 'cash-purchase-request-management',
                loadChildren:() => import('@/features/verify-pr-cash/verify-pr-cash-routing-module').then(m => m.VerifyPrCashRoutingModule),
                data: { breadcrumb: 'รายการตรวจสอบ PR เงินสดย่อย' }
            },
            {
                path: 'report',
                loadChildren:() => import('@/features/report-pr/report-pr-routing-module').then((m) => m.ReportPrRoutingModule),
                data: { breadcrumb: 'Reports' }
            },
            {
                path: 'compu',
                loadChildren:() => import('@/features/dashboard/dashboard-routing-module').then((m) => m.DashboardRoutingModule),
                data: { breadcrumb: 'Compu' }
            },
            {
                path: 'vendor',
                loadChildren:() => import('@/features/vendor-manage/vendor-manage-routing-module').then((m) => m.VendorManageRoutingModule),
                data: { breadcrumb: 'Vendor Management' }
            }
        ]
    }

    // { path: '**', redirectTo: '/notfound' }
];
